import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { MemoryRouter } from 'react-router';
import ImmersiveExperienceApp from 'src/ImmersiveExperienceApp';
import { useEffectOnce } from 'usehooks-ts';
import { system } from '@config/system';
import { isValidImmersiveExperienceModeSetting } from '@data/stores/Environment/types';
import { getInitialLocation, getLanguageForUrlPath, getSearchForUrlPath, } from '@view/webcomponents/helpers';
import { scriptAttributes } from '@config/index';
import { parseBoolean } from '@business/utils';
export const ImmersiveExperience = (props) => {
    const { currency, lang, ignoreSearchParams = false, mode, propertyCode: propPropertyCode, environment, island, } = Object.assign(Object.assign({}, scriptAttributes), props);
    const getBooleanAttribute = (name) => {
        if (name in props && props[name] !== undefined) {
            return Boolean(props[name]);
        }
        return parseBoolean(scriptAttributes[name]);
    };
    const disableCssTitleReset = getBooleanAttribute('disableCssTitleReset');
    const hideCustomFooter = getBooleanAttribute('hideCustomFooter');
    const hideCustomHeader = getBooleanAttribute('hideCustomHeader');
    const hidePropertyInfo = getBooleanAttribute('hidePropertyInfo');
    const [memoryRouterInitialLocation, setMemoryRouterInitialLocation] = useState('');
    useEffectOnce(() => {
        const systemOverride = {};
        if (environment) {
            systemOverride['environment'] = environment;
        }
        if (island) {
            systemOverride['island'] = island;
        }
        if (propPropertyCode) {
            systemOverride['propertyCode'] = propPropertyCode;
        }
        system.load(systemOverride);
        if (!system.propertyCode) {
            return;
        }
        // Ordered array, if duplicates, the first definition will be used.
        const search = getSearchForUrlPath(currency, ignoreSearchParams);
        const language = getLanguageForUrlPath(lang);
        setMemoryRouterInitialLocation(getInitialLocation({
            language,
            propertyCode: system.propertyCode,
            search,
        }));
    });
    return memoryRouterInitialLocation ? (_jsx(MemoryRouter, { initialEntries: [memoryRouterInitialLocation], children: _jsx(ImmersiveExperienceApp, { disableCssTitleReset: disableCssTitleReset, hideCustomFooter: hideCustomFooter, hideCustomHeader: hideCustomHeader, hidePropertyInfo: hidePropertyInfo, mode: isValidImmersiveExperienceModeSetting(mode) ? mode : undefined }) })) : null;
};
